const defaultState = {
    error: null,
    fetching: false,
    fetched: false
};

const postPresignedUrlReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'PRESIGNED_FILE_UPLOAD_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'PRESIGNED_FILE_UPLOAD_FETCH_FULFILLED': {
            return {
                ...state, fetching: false, fetched: true, error: null, fileUploaded: true
            };
        }
        case 'PRESIGNED_FILE_UPLOAD_FETCH_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default postPresignedUrlReducer;


// WEBPACK FOOTER //
// ./src/reducers/postPresignedUrl.js